export const language: any = {
  LabelCarts: "ตะกร้าสินค้า",
  Material: "วัสดุ",
  nodata: "ไม่มีข้อมูลในตะกร้าสินค้า",
};

